import API from "./api";

// const API_BASE_URL = "https://tendinous-kalel-unplumb.ngrok-free.dev/api"; // change to your backend

const normalizeInterviewDateForApi = (date) => {
  if (!date || typeof date !== "string") {
    return date;
  }

  const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;

  if (!isoDatePattern.test(date)) {
    return date;
  }

  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
};

// export const scheduleInterview = async (applicationId, data) => {
//   const response = await axios.post(
//     `${API_BASE_URL}/applications/${applicationId}/schedule-interview`,
//     data,

//   );

//   return response.data;
// };

export const scheduleInterview = async (applicationId, data) => {
  const payload = {
    ...data,
    date: normalizeInterviewDateForApi(data?.date),
  };

  const res = await API.post(
    `/applications/${applicationId}/schedule-interview`,
    payload,
  );
  return res.data;
};

export const getInterviews = async () => {
  const response = await API.get(
    `/applications/filter?status=INTERVIEW_SCHEDULED`,
  );
  return response.data;
};
